import React from 'react';
import { Modal } from 'react-bootstrap';
import { LabelText } from '../../../components/Language/LabelText';
import Button from 'react-bootstrap/Button';
import './Model.css';
import '../Filter/MultiSelect.css';

const Model = (props) => {
    return (
        <div className="Modal-container">
            <Modal show={props.showModel} onHide={() => { props.onHideHandler(); }}>
                {
                    props.showHeader &&
                    <Modal.Header closeButton className="Modal-header" >
                        <Modal.Title className="Model-header-title">{<LabelText tid={props.headerTitle} />}</Modal.Title>
                    </Modal.Header>
                }
                <Modal.Body>
                    {props.showSuccess ?
                        <div>
                            <div className="Saved-success-icon"></div>
                            <div className="Saved-success-message-container">
                               {props.additionInfo && <span className="Saved-success-message">{props.additionInfo }</span>} <span className="Saved-success-message">{<LabelText tid={props.successMessage} />}</span>
                               <div>{props.successFullMessage !== "" && <span className="Saved-success-message">{<LabelText tid={props.successFullMessage} />}</span>}</div>
                            </div>
                        </div>
                        : props.showError ? 
                            props.errorMessage ==="all_mandatory" ? 
                                <div>
                                    <div className="Saved-failure-icon"></div>
                                    <div className="Error-message-container">
                                       <span className="Error-message" >{<LabelText tid={props.errorMessage} />}</span>
                                    </div>
                                </div> 
                            : 
                                <div className="Error-message-container">
                                    <span className="Error-message" >{<LabelText tid={props.errorMessage} />}</span>
                                </div>
                        : props.showInstructions ?
                             !props.isMonthlyIntakeBook ?
                             <div style={{fontSize: "0.85vw"}}>
                                <p className="instructions-labels">- <LabelText tid="vatinputdecimal" /></p>
                                <p className="instructions-labels">- <LabelText tid="soldtcknum" /></p>
                                <p className="instructions-labels">- <LabelText tid="shopopen_yesno" /></p>
                                {props.isBusinessPartner && <p className="instructions-labels">- <LabelText tid="futuredateInstruction" /></p>}
                                <p className="instructions-labels">- <LabelText tid="maxvalue" /></p>
                                {props.isBusinessPartner && <p className="instructions-labels">- <LabelText tid="submission_allmandatory" /></p>}
                                {props.isBusinessPartner && <p className="instructions-labels">- <LabelText tid="lockedcontractssubmission" /></p> } 
                                {props.isBusinessPartner && <p className="instructions-labels">- <LabelText tid="instruction_max_cr_allowed" /></p> } 
                                {props.isBusinessPartner && <p className="instructions-labels">- <LabelText tid="instruction_one_cr_per_contract" /></p> } 
                                {props.isBusinessPartner && <p className="instructions-labels">- <LabelText tid="instruction_donot_translate" /></p> }
                                {!props.isBusinessPartner && <p className="instructions-labels">- <LabelText tid="editreceiptjournal" /></p> }                             
                             </div> :                            
                            <div style={{fontSize: "0.85vw"}}>
                                <p className="instructions-labels">- <LabelText tid="uploadjournal" /></p>
                                <p className="instructions-labels">- <LabelText tid="onejournalallowed" /></p>
                                <p className="instructions-labels">- <LabelText tid="fileformat" /></p>
                                <p className="instructions-labels">- <LabelText tid="maxjournalfilesize" /></p>
                                <p className="instructions-labels">- <LabelText tid="downloadjournal" /></p>   
                                <p className="instructions-labels">- <LabelText tid="instruction_max_cr_allowed" /></p>
                                <p className="instructions-labels">- <LabelText tid="instruction_one_cr_per_contract" /></p>
                                <p className="instructions-labels">- <LabelText tid="instruction_donot_translate" /></p>
                            </div>
                        : undefined
                    }
                </Modal.Body>
                {props.headerTitle && (props.headerTitle === "unsaved_changes" || props.headerTitle === "Upload_Cash_Register") &&
                    <Modal.Footer>
                        <Button variant="primary"  className="ok-btn" size="sm"
                            onClick={() => props.handleConfirmationYesClick()} ><LabelText tid="yes" /></Button>
                        <Button variant="secondary" size="sm"
                            onClick={() => props.onHideHandler()} ><LabelText tid="no" /></Button>
                    </Modal.Footer>}
            </Modal>
        </div>)
}

export default Model;